module.exports = __webpack_public_path__ + "static/media/my-account-icon.f88fea44.png";